export const ProviderKind = {
  Pos: 0,
  Payment: 1,
  Pms: 2,
  Loyalty: 3,
  Feedback: 4,
} as const;

export type ProviderKind = (typeof ProviderKind)[keyof typeof ProviderKind];
